import React, { useContext } from 'react';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import { Table } from 'react-bootstrap';
import classes from '../TableContainer/index.module.scss';

const TableContainer = () => {
  return (
    <div className={classes.Table_Wrapper}>
      <Table striped responsive className={classes.Table}>
        <thead className={classes.Table_Head}>
          <TableHeader />
        </thead>
        <tbody className={classes.Table_Body}>
          <TableBody /> 
        </tbody>
      </Table>
    </div>
  )
}

export default TableContainer;